// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__k4XfY","preLoader":"Loader_preLoader__oeqXn","loader":"Loader_loader__3Fg6Q"};